export default __webpack_public_path__ + "static/media/face-3.671d3997.svg";